import {Component, Input, OnInit} from '@angular/core';
import {MaintenanceModeConfig} from '../../model/maintenance-config/maintenance-mode-config';
import {DateUtil} from '../utils/Date/date-util';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../../services/language/language.service';

@Component({
  selector: 'app-info-maintenance',
  templateUrl: './info-maintenance.component.html',
  styleUrls: ['./info-maintenance.component.less']
})
export class InfoMaintenanceComponent implements OnInit {

  @Input()
  maintenanceModeConfig: MaintenanceModeConfig;

  startDayName: string;
  startDayHour: string;
  startDayMinutes: string;
  endDayName: string;
  endDayHour: string;
  endDayMinutes: string;

  constructor(private translateService: TranslateService,
              private languageService: LanguageService) {
  }

  ngOnInit() {
    this.setDateInfo();
  }

  private setDateInfo(): void {
    this.startDayName = DateUtil.getNameOfDay(this.maintenanceModeConfig.startDate, this.languageService.getCurrentLanguage());
    this.endDayName = DateUtil.getNameOfDay(this.maintenanceModeConfig.endDate, this.languageService.getCurrentLanguage());
    this.startDayHour = this.maintenanceModeConfig.startDate.getHours() + '';
    this.startDayMinutes = this.maintenanceModeConfig.startDate.getMinutes() + '';
    this.endDayHour = this.maintenanceModeConfig.endDate.getHours() + '';
    this.endDayMinutes = this.maintenanceModeConfig.endDate.getMinutes() + '';
  }
}
